module.exports = __webpack_public_path__ + "static/media/side-effects.748bf55a.svg";